"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _core = require("@material-ui/core");

var _Table = _interopRequireDefault(require("@material-ui/core/Table"));

var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = require("prop-types");

var React = _interopRequireWildcard(require("react"));

var Buttons = _interopRequireWildcard(require("../../../components/input/button/Button"));

var css = _interopRequireWildcard(require("./ZipPayContract.styles"));

var _ZipPay = _interopRequireDefault(require("./svg/ZipPay"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  companyName: 'ZipMoney Payments Pty Ltd',
  businessNumber: 'ABN 58 164 440 993',
  acceptanceDate: (0, _moment["default"])().format('DD MMMM, YYYY')
};

var ZipPayContractSummary = function ZipPayContractSummary(_ref) {
  var companyName = _ref.companyName,
      businessNumber = _ref.businessNumber,
      customerName = _ref.customerName,
      customerAddress = _ref.customerAddress,
      customerEmail = _ref.customerEmail,
      customerMobile = _ref.customerMobile,
      accountLimit = _ref.accountLimit,
      minimumMonthlyRepayment = _ref.minimumMonthlyRepayment,
      dueDate = _ref.dueDate,
      monthlyServiceFee = _ref.monthlyServiceFee,
      latePaymentFee = _ref.latePaymentFee,
      acceptanceDate = _ref.acceptanceDate,
      toggleView = _ref.toggleView;
  return (0, _jsxRuntime.jsx)(_core.Box, {
    css: css.body,
    children: (0, _jsxRuntime.jsxs)(_core.Box, {
      css: css.content,
      children: [(0, _jsxRuntime.jsx)(_ZipPay["default"], {
        css: css.zipLogo
      }), (0, _jsxRuntime.jsx)("h2", {
        className: "title3",
        css: css.contractHeader,
        children: "Zip Pay Schedule"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: [companyName, " ", businessNumber, " (\"Zip\") offers to provide the Account Holder named below (\"You\") with a Zip Pay Account on the contract terms in this Schedule and the Zip Pay Terms and Conditions (\"Contract\"). To accept this offer you must sign the Zip Pay Schedule below by clicking \"Accept\". Once you accept our offer the Contract will automatically form a binding agreement between the Account Holder and Zip."]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.tableTop
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTableCaption,
        children: "Account Holder"
      }), (0, _jsxRuntime.jsx)(_Table["default"], {
        "aria-label": "simple table",
        css: css.table,
        children: (0, _jsxRuntime.jsxs)(_TableBody["default"], {
          children: [(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: "Name:"
              })
            }), (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: customerName
              })
            })]
          }, "a"), (0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: "Address:"
              })
            }), (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: customerAddress
              })
            })]
          }, "b"), (0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: "Email Address:"
              })
            }), (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: customerEmail
              })
            })]
          }, "c"), (0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: "Mobile Phone:"
              })
            }), (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: customerMobile
              })
            })]
          }, "d")]
        })
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTableCaption,
        children: "Key Terms"
      }), (0, _jsxRuntime.jsx)(_Table["default"], {
        "aria-label": "simple table",
        css: css.table,
        children: (0, _jsxRuntime.jsxs)(_TableBody["default"], {
          children: [(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: "Account Limit:"
              })
            }), (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                id: "contract-creditLimit",
                children: accountLimit
              })
            })]
          }, "a"), (0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: "Minimum Repayment Amount:"
              })
            }), (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsxs)("p", {
                children: [minimumMonthlyRepayment, " per month (if your Outstanding Balance is less than ", minimumMonthlyRepayment, " you only need to pay the balance owing)"]
              })
            })]
          }, "b"), (0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: "Due Date:"
              })
            }), (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: dueDate
              })
            })]
          }, "c"), (0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: "Account Fee:"
              })
            }), (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsxs)("p", {
                children: [monthlyServiceFee, " per month. The Account Fee is waived if you pay your Closing Balance in full by the Due Date."]
              })
            })]
          }, "d"), (0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsx)("p", {
                children: "Late Payment Fee:"
              })
            }), (0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: (0, _jsxRuntime.jsxs)("p", {
                children: [latePaymentFee, " added to your Account when any Minimum Repayment Amount is not paid within 21 days after your Due Date"]
              })
            })]
          }, "e")]
        })
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 2,
        mt: 2,
        css: css.textEmphasis,
        children: "ACKNOWLEDGEMENT & ACCEPTANCE"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "By signing this Schedule You acknowledge:"
      }), (0, _jsxRuntime.jsxs)("ul", {
        css: css.bulletPoints,
        children: [(0, _jsxRuntime.jsxs)("li", {
          children: ["That you have read and accept the offer set out in this Schedule and the", ' ', (0, _jsxRuntime.jsx)(Buttons.Text, {
            css: css.linkButton,
            onClick: function onClick() {
              return toggleView(false);
            },
            children: "Zip Pay Terms & Conditions"
          })]
        }), (0, _jsxRuntime.jsx)("li", {
          children: "That by providing your email address you authorise Zip to give you such documents by email as are permitted to be given electronically;"
        }), (0, _jsxRuntime.jsx)("li", {
          children: "That you have entered this contract freely, and understand your obligations to us and responsibilities under this Contract"
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mt: 2,
        children: (0, _jsxRuntime.jsx)(_Table["default"], {
          "aria-label": "simple table",
          css: css.table,
          children: (0, _jsxRuntime.jsx)(_TableBody["default"], {
            children: (0, _jsxRuntime.jsxs)(_TableRow["default"], {
              children: [(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: (0, _jsxRuntime.jsx)("p", {
                  children: "Acceptance Date:"
                })
              }), (0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: (0, _jsxRuntime.jsx)("p", {
                  children: acceptanceDate
                })
              })]
            }, "a")
          })
        })
      })]
    })
  });
};

ZipPayContractSummary.propTypes = {
  companyName: _propTypes.string,
  businessNumber: _propTypes.string,
  customerName: _propTypes.string.isRequired,
  customerAddress: _propTypes.string.isRequired,
  customerEmail: _propTypes.string.isRequired,
  customerMobile: _propTypes.string.isRequired,
  accountLimit: _propTypes.string.isRequired,
  minimumMonthlyRepayment: _propTypes.string.isRequired,
  dueDate: _propTypes.string.isRequired,
  monthlyServiceFee: _propTypes.string.isRequired,
  latePaymentFee: _propTypes.string.isRequired,
  acceptanceDate: _propTypes.string,
  toggleView: _propTypes.func.isRequired
};
ZipPayContractSummary.defaultProps = defaultProps;
var _default = ZipPayContractSummary;
exports["default"] = _default;